// removed by extract-text-webpack-plugin
module.exports = {"box":"box__3S5sP","oneHorizontal":"oneHorizontal__1YvxY","oneVertical":"oneVertical__3tZ2p","twoHorizontal":"twoHorizontal__Q-BWx","twoVertical":"twoVertical__CBcYv","number":"number__2fh4h","solution__box":"solution__box__2BUmI"};


//////////////////
// WEBPACK FOOTER
// ./components/solution/style.css
// module id = tkYV
// module chunks = 2